import React, { useRef, useState } from "react";
import "./Apply.css";

// Replace with your Formspree form ID (formspree.io/f/YOUR_FORM_ID)
const FORMSPREE_ID = "xwvjkwnj";

function ApplicationForm() {
  const formRef = useRef();
  const [status, setStatus] = useState("idle"); // idle | sending | success | error
  const [errors, setErrors] = useState({});

  function validateField(name, value) {
    const num = Number(value);
    if (name === "chess_elo") {
      if (value === "") return null;
      if (num <= 1200) return "Um okay. Maybe read Modern Chess Openings or something.";
    }
    if (name === "polar_bear_days") {
      if (value === "") return null;
      if (num < 5) return "Under 5 days? Can't be showing me up.";
      if (num >= 14) return "Over two weeks? More like Slowlar Bear Challenge.";
    }
    return null;
  }

  function handleBlur(e) {
    const { name, value } = e.target;
    const error = validateField(name, value);
    setErrors((prev) => ({ ...prev, [name]: error }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    const elo = formRef.current.chess_elo.value;
    const days = formRef.current.polar_bear_days.value;
    const errs = {
      chess_elo: validateField("chess_elo", elo),
      polar_bear_days: validateField("polar_bear_days", days),
    };
    if (Object.values(errs).some(Boolean)) {
      setErrors(errs);
      return;
    }
    setErrors({});
    setStatus("sending");
    fetch(`https://formspree.io/f/${FORMSPREE_ID}`, {
      method: "POST",
      body: new FormData(formRef.current),
      headers: { Accept: "application/json" },
    })
      .then((res) => (res.ok ? setStatus("success") : setStatus("error")))
      .catch(() => setStatus("error"));
  }

  if (status === "success") {
    return (
      <div className="form-result">
        <p>✅ Application received. Stephen will be in touch if you meet the bar.</p>
      </div>
    );
  }

  return (
    <form ref={formRef} onSubmit={handleSubmit} className="apply-form">
      <div className="form-field">
        <label htmlFor="applicant_name">Name</label>
        <input id="applicant_name" name="applicant_name" type="text" required />
      </div>

      <div className="form-field">
        <label htmlFor="applicant_email">Your Email</label>
        <input id="applicant_email" name="applicant_email" type="email" required />
      </div>

      <div className="form-field">
        <label htmlFor="chess_elo">Rapid Chess ELO</label>
        <input id="chess_elo" name="chess_elo" type="number" min="0" required onBlur={handleBlur} />
        {errors.chess_elo && <p className="form-error">{errors.chess_elo}</p>}
      </div>

      <div className="form-field">
        <label htmlFor="polar_bear_days">Dolphin Club Polar Bear Challenge — days to complete</label>
        <input
          id="polar_bear_days"
          name="polar_bear_days"
          type="number"
          min="0"
          step="0.1"
          required
          onBlur={handleBlur}
        />
        {errors.polar_bear_days && <p className="form-error">{errors.polar_bear_days}</p>}
      </div>

      <div className="form-field">
        <label htmlFor="chess_pickup_line">Chess opening pickup line</label>
        <textarea id="chess_pickup_line" name="chess_pickup_line" rows="3" required />
      </div>

      <div className="form-field">
        <label htmlFor="additional_info">Anything else Stephen should know?</label>
        <textarea id="additional_info" name="additional_info" rows="4" />
      </div>

      {status === "error" && (
        <p className="form-error">Something went wrong. Please try again.</p>
      )}

      <button type="submit" disabled={status === "sending"} className="submit-btn">
        {status === "sending" ? "Submitting…" : "Submit Application"}
      </button>
    </form>
  );
}

function Apply() {
  return (
    <div className="apply-root">
      <header className="apply-header">
        <h1>💌 Girlfriend Application</h1>
        <p className="tagline">
          Thank you for your interest in Stephen Balhoff. Please review all
          minimum qualifications before applying.
        </p>
      </header>

      <main className="apply-main">
        <section className="apply-section">
          <h2>📋 Minimum Qualifications</h2>
          <p>All candidates must meet the following requirements in full. No exceptions.</p>
          <ul>
            <li>
              <span className="qualifier">Rapid Chess ELO &gt; 1200.</span> Unrated and bullet-only players will not be considered.
            </li>
            <li>
              <span className="qualifier">Game.</span> Must be able to rattle off a
              pickup line that references a book opening.
            </li>
            <li>
              <span className="qualifier">Cold water tolerance.</span> Completed the
              Dolphin Club Polar Bear Challenge in less than 14 days, but not less
              than 5 days.
            </li>
          </ul>
        </section>

        <section className="apply-section">
          <h2>ℹ️ About This Role</h2>
          <p>
            The position of Girlfriend to Stephen Balhoff is highly competitive
            and comes with considerable prestige. Successful candidates will be
            expected to appreciate both elite aquatic performance and opening
            theory.
          </p>
          <p>
            This is a full-time commitment. Part-time or hybrid arrangements are
            not available at this time.
          </p>
        </section>

        <section className="apply-section">
          <h2>📝 Apply Now</h2>
          <ApplicationForm />
        </section>
      </main>

      <footer className="apply-footer">
        <p>© 2026 Stephen Balhoff — Applications reviewed on a rolling basis</p>
      </footer>
    </div>
  );
}

export default Apply;
